import {
  APPEND_MESSAGE,
  REMOVE_MESSAGE,
  SET_USER_CHATROOMS,
  REPLACE_MESSAGE,
  SET_CHAT_FILTERS,
  SEND_MESSAGE_START,
  SEND_MESSAGE_RESET,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILURE,
  NEW_CONVERSATION_START,
  SET_ACTIVE_CONVERSATION,
  NEW_CONVERSATION_SUCCESS,
  NEW_CONVERSATION_FAILURE,
  START_CONVERSATION_START,
  FETCH_CHAT_MESSAGE_START,
  SET_UNREAD_MESSAGE_COUNT,
  DELETE_CONVERSATION_START,
  GET_BULK_SEND_USERS_START,
  START_CONVERSATION_SUCCESS,
  START_CONVERSATION_FAILURE,
  FETCH_USER_CHATROOMS_START,
  FETCH_CHAT_MESSAGE_SUCCESS,
  FETCH_CHAT_MESSAGE_FAILURE,
  DELETE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_FAILURE,
  SEND_MESSAGE_SET_INPUT_DATA,
  FETCH_USER_CHATROOMS_FAILURE,
  FETCH_USER_CHATROOMS_SUCCESS,
  UNLOCK_MESSAGE_PAYMENT_START,
  GET_BULK_SEND_USERS_SUCCESS,
  GET_BULK_SEND_USERS_FAILURE,
  GET_BULK_SEND_METADATA_START,
  UNLOCK_MESSAGE_PAYMENT_FAILURE,
  UNLOCK_MESSAGE_PAYMENT_SUCCESS,
  GET_BULK_SEND_METADATA_SUCCESS,
  GET_BULK_SEND_METADATA_FAILURE,
  SET_ACTIVE_CONVERSATION_LOADING,
  SET_CHATROOMS_USER_ONLINE_STATUS,
  SET_ACTIVE_CONVERSATION_IF_CURRENT,
  GET_BULK_SEND_USERS_TOGGLE_SELECTED,
  SET_ACTIVE_CHATROOM_USER_ONLINE_STATUS,
  FETCH_UNREAD_MESSAGE_AND_NOTIFICATION_COUNT
} from "./ActionConstant";

export function sendMessageStart(data) {
  return {
    type: SEND_MESSAGE_START,
    data,
  };
}

export function sendMessageReset(data) {
  return {
    type: SEND_MESSAGE_RESET,
    data,
  };
}

export function sendMessageSuccess(data) {
  return {
    type: SEND_MESSAGE_SUCCESS,
    data,
  };
}

export function sendMessageFailure(error) {
  return {
    type: SEND_MESSAGE_FAILURE,
    error,
  };
}

export function sendMessageSetInputData(data) {
  return {
    type: SEND_MESSAGE_SET_INPUT_DATA,
    data,
  };
}

export function newConversationStart(data) {
  return {
    type: NEW_CONVERSATION_START,
    data,
  };
}

export function newConversationSuccess(data) {
  return {
    type: NEW_CONVERSATION_SUCCESS,
    data,
  };
}

export function newConversationFailure(error) {
  return {
    type: NEW_CONVERSATION_FAILURE,
    error,
  };
}

export function startConversationStart(data) {
  return {
    type: START_CONVERSATION_START,
    data,
  };
}

export function startConversationSuccess(data) {
  return {
    type: START_CONVERSATION_SUCCESS,
    data,
  };
}

export function startConversationFailure(error) {
  return {
    type: START_CONVERSATION_FAILURE,
    error,
  };
}

export function deleteConversationStart(data) {
  return {
    type: DELETE_CONVERSATION_START,
    data,
  };
}

export function deleteConversationSuccess(data) {
  return {
    type: DELETE_CONVERSATION_SUCCESS,
    data,
  };
}

export function deleteConversationFailure(error) {
  return {
    type: DELETE_CONVERSATION_FAILURE,
    error,
  };
}

export function fetchUserChatroomsStart(data) {
  return {
    type: FETCH_USER_CHATROOMS_START,
    data,
  };
}

export function fetchUserChatroomsSuccess(data) {
  return {
    type: FETCH_USER_CHATROOMS_SUCCESS,
    data,
  };
}

export function fetchUserChatroomsFailure(error) {
  return {
    type: FETCH_USER_CHATROOMS_FAILURE,
    error,
  };
}

export function fetchChatMessageStart(data) {
  return {
    type: FETCH_CHAT_MESSAGE_START,
    data,
  };
}

export function fetchChatMessageSuccess(data) {
  return {
    type: FETCH_CHAT_MESSAGE_SUCCESS,
    data,
  };
}

export function fetchChatMessageFailure(error) {
  return {
    type: FETCH_CHAT_MESSAGE_FAILURE,
    error,
  };
}

export function appendMessage(data) {
  return {
    type: APPEND_MESSAGE,
    data
  };
}

export function removeMessage(data) {
  return {
    type: REMOVE_MESSAGE,
    data
  };
}

export function replaceMessage(data) {
  return {
    type: REPLACE_MESSAGE,
    data
  };
}


export function setUserChatRooms(data) {
  return {
    type: SET_USER_CHATROOMS,
    data
  }
}

export function setActiveConversation(data) {
  return {
    type: SET_ACTIVE_CONVERSATION,
    data
  }
}

export function setActiveConversationLoading(data) {
  return {
    type: SET_ACTIVE_CONVERSATION_LOADING,
    data
  }
}

export function setActiveConversationIfCurrent(data) {
  return {
    type: SET_ACTIVE_CONVERSATION_IF_CURRENT,
    data
  }
}

export function setChatroomsUserOnlineStatus(data) {
  return {
    type: SET_CHATROOMS_USER_ONLINE_STATUS,
    data
  }
}

export function setActiveChatroomUserOnlineStatus(data) {
  return {
    type: SET_ACTIVE_CHATROOM_USER_ONLINE_STATUS,
    data
  }
}

export function unlockMessagePaymentStart(data) {
  return {
    type: UNLOCK_MESSAGE_PAYMENT_START,
    data,
  };
}

export function unlockMessagePaymentSuccess(data) {
  return {
    type: UNLOCK_MESSAGE_PAYMENT_SUCCESS,
    data,
  };
}

export function unlockMessagePaymentFailure(error) {
  return {
    type: UNLOCK_MESSAGE_PAYMENT_FAILURE,
    error,
  };
}

export function fetchBulkSendUserStart(data) {
  return {
    type: GET_BULK_SEND_USERS_START,
    data,
  };
}

export function fetchBulkSendUserSuccess(data) {
  return {
    type: GET_BULK_SEND_USERS_SUCCESS,
    data,
  };
}

export function fetchBulkSendUserFailure(error) {
  return {
    type: GET_BULK_SEND_USERS_FAILURE,
    error,
  };
}

export function toggleBulkSendUserSelected(data) {
  return {
    type: GET_BULK_SEND_USERS_TOGGLE_SELECTED,
    data,
  };
}

export function fetchBulkSendMetadataStart(data) {
  return {
    type: GET_BULK_SEND_METADATA_START,
    data,
  };
}

export function fetchBulkSendMetadataSuccess(data) {
  return {
    type: GET_BULK_SEND_METADATA_SUCCESS,
    data,
  };
}

export function fetchBulkSendMetadataFailure(error) {
  return {
    type: GET_BULK_SEND_METADATA_FAILURE,
    error,
  };
}

export function setChatFilters(data) {
  return {
    type: SET_CHAT_FILTERS,
    data,
  };
}

export function fetchMessageAndNotificationCountStart() {
  return {
    type: FETCH_UNREAD_MESSAGE_AND_NOTIFICATION_COUNT
  }
}

export function setUnreadMessageCount(data) {
  return {
    type: SET_UNREAD_MESSAGE_COUNT,
    data
  }
}
